import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React from 'react';
import { ReactForms } from '@rexlabs/form';
import { FormRendererInner } from './inner';
export function FormRenderer(props) {
  var schema = props.schema,
      context = props.context,
      initialValues = props.initialValues,
      customInputs = props.customInputs,
      render = props.render,
      children = props.children,
      TextInput = props.TextInput,
      TextAreaInput = props.TextAreaInput,
      RadioGroupInput = props.RadioGroupInput,
      CheckboxInput = props.CheckboxInput,
      SelectInput = props.SelectInput,
      MultiSelectInput = props.MultiSelectInput,
      DateInput = props.DateInput,
      DateTimeInput = props.DateTimeInput,
      TimeInput = props.TimeInput,
      HiddenInput = props.HiddenInput,
      rest = _objectWithoutProperties(props, ["schema", "context", "initialValues", "customInputs", "render", "children", "TextInput", "TextAreaInput", "RadioGroupInput", "CheckboxInput", "SelectInput", "MultiSelectInput", "DateInput", "DateTimeInput", "TimeInput", "HiddenInput"]);

  return /*#__PURE__*/React.createElement(ReactForms, rest, function (form) {
    return /*#__PURE__*/React.createElement(FormRendererInner, _extends({}, props, {
      form: form
    }));
  });
}